import { Create, SimpleForm } from 'react-admin';

import { ChargingStationClusterForm } from './form';
import { transform } from '../../../common/TranslationInput';

export const ChargingStationClusterCreate = () => {
  return (
    <Create transform={(data) => transform(data, 'name')}>
      <SimpleForm>
        <ChargingStationClusterForm />
      </SimpleForm>
    </Create>
  );
};
